import { type FieldValidator, type PrimitiveField, type ValidationError } from '@adv-frontend/form-kit';

/*
 * Создает валидатор-обертку для необязательных полей
 *
 * @param validator необязательный валидатор
 * @returns валидатор
 */
export function unRequiredValidator<
    Code extends string,
    FieldValue extends string,
    FieldContextInput,
    FieldContext,
    FieldActions,
    FieldSelectors,
>(
    validator: FieldValidator<
        PrimitiveField<FieldValue, ValidationError<Code>, FieldContextInput, FieldContext, FieldActions, FieldSelectors>
    >
): FieldValidator<
    PrimitiveField<FieldValue, ValidationError<Code>, FieldContextInput, FieldContext, FieldActions, FieldSelectors>
> {
    return (value, fieldApi, signal) => {
        if (value) {
            return validator(value, fieldApi, signal);
        }
    };
}
